import {HALF_PI} from '../constants/values';

export default function(eccent, phi, sinphi) {
  var con = eccent * sinphi;
  var com = 0.5 * eccent;
  con = Math.pow(((1 - con) / (1 + con)), com);
  return (Math.tan(0.5 * (HALF_PI - phi)) / con);
}



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/tsfnz.js
// module id = ME/f
// module chunks = 0